import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import DashboardCard from "../../pages/home/common/DashboardCard";
import { convertThenFormat } from "../common-data/Converts";
import Loader from "../ui/Loader";
import { sumTwoNumbers } from "../common-data/Conversions";
import HeaderLine from "./common/HeaderLine";

const CmnLeadCards = ({
  onClickLeadCard,
  prevClickedCard,
  tableRef,
  mobileTableRef,
  setIsConvertedModal,
  rawLeads,
  setRawLeads,
  activeCardIndex,
  setActiveCardIndex,
  setLastAssigned,
}) => {
  const {
    leadStatsLoading,
    leadStats,

    rawLeadLoading,
    rawLeadData,
    rawLeadStatsLoading,
    rawLeadStats,
  } = useSelector((state) => state.api);

  const [leadStatsData, setLeadStatsData] = useState({});

  const EXCLUDED_KEYS = [
    "first_call_missed",
    "first_call",
    "total_walkins",
    "total_walkins_today",
    "lead_values",
    "lead_values_converted",
    "lead_value_added_today",
    "lead_values_converted_today",
    "pending_leads",
    "hot_leads",
    "semi_hot_leads",
    "warm_leads",
    "cold_leads",
    "hot_missed",
    "closure_expected_today",
    "closure_expected_tomorrow",
    "todays_follow_ups",
    "missed_followups",
    "tomorrows_follow_ups",
    "one_day_membership_completed",
    "one_day_membership_pending",
  ];

  const HIGHLIGHTED_KEYS = [
    "closure_expected_today",
    "closure_expected_tomorrow",
    "todays_follow_ups",
    "tomorrows_follow_ups",
    "missed_followups",
  ];

  const getCardLabel = (key) => {
    switch (key) {
      case "pending_leads":
        return "Pending Followup";
      case "todays_leads":
        return "Today Added Lead Value";
      case "asigned_leads":
        return "Raw Leads";
      default:
        return key.replace(/_/g, " ");
    }
  };

  const getCardSubLabel = (key) => {
    switch (key) {
      case "asigned_leads":
        return "(Added/Not Added To Lead)";
      case "duplicate_leads":
        return "(Already Added To Lead)";
      case "new_raw_leads":
        return "(Not Added To Lead)";
      case "referral":
        return "(Not Added To Lead)";
      default:
        return key.replace(/_/g, " ");
    }
  };

  const getCardValue = (key, value) => {
    if (key === "todays_leads") {
      return `₹${convertThenFormat(
        leadStatsData?.data?.lead_value_added_today || 0
      )} (${value || 0})`;
    }
    return `${value || 0}`;
  };

  const handleCardClick = (key, index) => {
    const keyName =
      key === "all_leads"
        ? "all"
        : key === "todays_leads"
        ? "today"
        : key === "closed_leads"
        ? "closed"
        : key === "converted_leads"
        ? "converted"
        : key === "hot_leads"
        ? "hot"
        : key === "semi_hot_leads"
        ? "semi_hot"
        : key === "cold_leads"
        ? "cold"
        : key === "warm_leads"
        ? "warm"
        : key;

    if (
      key === "lead_values_converted" ||
      key === "lead_values_converted_today" ||
      key === "customer_not_in_lms_but_paid" ||
      key === "raw_leads" ||
      key === "duplicate_leads" ||
      key === "new_raw_leads" ||
      key === "one_day_membership" ||
      key === "BTL_leads" ||
      key === "referral" ||
      key === "wati_leads"
    ) {
      setIsConvertedModal(true);
      onClickLeadCard(keyName);
    } else {
      setActiveCardIndex((prevIndex) => (prevIndex === index ? null : index));
      onClickLeadCard(prevClickedCard === keyName ? "" : keyName);

      tableRef?.current?.scrollIntoView({ behavior: "smooth" });
      mobileTableRef?.current?.scrollIntoView({ behavior: "smooth" });
      setIsConvertedModal(false);
    }
  };

  useEffect(() => {
    if (leadStats?.status && leadStats?.data) {
      setLeadStatsData(leadStats);
    } else {
      setLeadStatsData({});
    }
  }, [leadStats]);

  useEffect(() => {
    if (rawLeadData?.status && rawLeadData?.data) {
      setRawLeads((prevs) => ({
        ...prevs,
        rawLeadStats: rawLeadData?.stats_data,
        allRawLeadData: rawLeadData?.data,
        rawLeadPagination: rawLeadData?.pagination,
      }));
    } else {
      setRawLeads((prevs) => ({
        ...prevs,
        rawLeadStats: {},
        allRawLeadData: [],
        rawLeadPagination: [],
      }));
    }
  }, [rawLeadData]);

  useEffect(() => {
    if (rawLeadStats?.status) {
      setRawLeads((prevs) => ({
        ...prevs,
        unassignedRawLeads: rawLeadStats.data?.[0]?.asigned_leads || 0,
        unassignedRawLeadsStats: rawLeadStats.data?.[0] || {},
        btlLeadsStats: rawLeadStats?.btl_stats || null,
        watiLeadStats: rawLeadStats?.wati_stats || null,
      }));

      setLastAssigned(rawLeadStats?.last_added_to_lead || null);
    } else {
      setRawLeads((prevs) => ({
        ...prevs,
        unassignedRawLeads: "",
        unassignedRawLeadsStats: {},
        btlLeadsStats: null,
        watiLeadStats: {},
      }));

      setLastAssigned(null);
    }
  }, [rawLeadStats]);

  return (
    <>
      <HeaderLine text="Leads Added From External Sources" isMT={true} />

      <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
        {!rawLeadStatsLoading && (
          <>
            {rawLeads.unassignedRawLeadsStats &&
              Object.entries(rawLeads.unassignedRawLeadsStats).map(
                ([key, value], index) => (
                  <DashboardCard
                    key={key}
                    tagName={key}
                    cardLabel={getCardLabel(key)}
                    subLabel={getCardSubLabel(key)}
                    value={value}
                    onClickCard={handleCardClick}
                    isLead={true}
                    cardIndex={index}
                    isActiveCard={activeCardIndex === key}
                  />
                )
              )}
          </>
        )}

        {!leadStatsLoading && (
          <DashboardCard
            key={"one_day_membership"}
            tagName={"one_day_membership"}
            cardLabel={"One Day Membership"}
            subLabel={"(Not Added To Lead)"}
            value={sumTwoNumbers(
              leadStatsData?.data?.one_day_membership_completed,
              leadStatsData?.data?.one_day_membership_pending
            )}
            // onClickCard={handleCardClick}
            isLead={true}
          />
        )}

        {rawLeadLoading ? (
          <Loader />
        ) : (
          <DashboardCard
            tagName={"raw_lead"}
            cardLabel={"Customer Not In LMS But Paid"}
            value={`₹${convertThenFormat(
              rawLeads.rawLeadStats?.total_price || 0
            )}(${rawLeads.rawLeadStats?.total_member || 0})`}
            onClickCard={handleCardClick}
            isLead={true}
          />
        )}

        {rawLeads.btlLeadsStats && (
          <DashboardCard
            tagName={"BTL_leads"}
            cardLabel={"BTL Leads (added to LMS/total)"}
            value={`${rawLeads.btlLeadsStats?.addedto_lead || 0}/${
              rawLeads.btlLeadsStats?.total_btl_lead || 0
            }`}
            onClickCard={handleCardClick}
            isLead={true}
          />
        )}

        {rawLeads.watiLeadStats && (
          <DashboardCard
            tagName={"wati_leads"}
            cardLabel={"Wati Leads"}
            subLabel={"(Not Added to Lead)"}
            value={`${rawLeads.watiLeadStats?.not_added_to_lead || 0}`}
            onClickCard={handleCardClick}
            isLead={true}
          />
        )}
      </div>

      <HeaderLine text="Lead Values" />

      <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
        {leadStatsData?.data &&
          Object.entries(leadStatsData?.data).map(([key, value], index) => (
            <React.Fragment key={index}>
              {(key === "lead_values" ||
                key === "lead_values_converted" ||
                key === "lead_values_converted_today") && (
                <DashboardCard
                  tagName={key}
                  cardLabel={key?.replace(/_/g, " ")}
                  value={`₹${convertThenFormat(value || 0)}`}
                  onClickCard={handleCardClick}
                  isLead={true}
                  cardIndex={index}
                  isActiveCard={activeCardIndex === key}
                />
              )}
            </React.Fragment>
          ))}
      </div>

      <HeaderLine text="Leads and followups" />

      {leadStatsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
          {leadStatsData?.data &&
            Object.entries(leadStatsData.data).map(
              ([key, value], index) =>
                !EXCLUDED_KEYS.includes(key) && (
                  <DashboardCard
                    key={key}
                    tagName={key}
                    cardLabel={getCardLabel(key)}
                    value={getCardValue(key, value)}
                    onClickCard={handleCardClick}
                    isLead={true}
                    cardIndex={index}
                    isActiveCard={activeCardIndex === key}
                  />
                )
            )}
        </div>
      )}

      <HeaderLine text="Lead Closures And followups" />

      <div className="cards-container cards-grid-container lead-cards grid-4 mt-2rem">
        {leadStatsData?.data &&
          Object.entries(leadStatsData?.data)
            .sort(([keyA], [keyB]) => {
              const indexA = HIGHLIGHTED_KEYS.indexOf(keyA);
              const indexB = HIGHLIGHTED_KEYS.indexOf(keyB);

              if (indexA === -1) return 1;
              if (indexB === -1) return -1;
              return indexA - indexB;
            })
            .map(([key, value], index) => (
              <React.Fragment key={index}>
                {HIGHLIGHTED_KEYS.includes(key) && (
                  <DashboardCard
                    tagName={key}
                    cardLabel={getCardLabel(key)}
                    value={`₹${convertThenFormat(
                      key === "closure_expected_today"
                        ? leadStatsData?.leadTypeValues
                            ?.closure_expected_today_value
                        : key === "closure_expected_tomorrow"
                        ? leadStatsData?.leadTypeValues
                            ?.closure_expected_tomorrow_value
                        : key === "todays_follow_ups"
                        ? leadStatsData?.leadTypeValues?.todays_follow_ups_value
                        : key === "tomorrows_follow_ups"
                        ? leadStatsData?.leadTypeValues
                            ?.tomorrows_follow_ups_value
                        : key === "missed_followups"
                        ? leadStatsData?.leadTypeValues?.missed_followups_value
                        : 0
                    )} (${getCardValue(key, value)})`}
                    onClickCard={handleCardClick}
                    isLead={true}
                    cardIndex={index}
                    isActiveCard={activeCardIndex === key}
                  />
                )}
              </React.Fragment>
            ))}
      </div>
    </>
  );
};

export default CmnLeadCards;
